<template>
  <div class="auth-page" id="formForgotPassword">
    <div class="auth-page__inner">
      <div class="auth-page__brand">
        <div class="auth-page__brand-bg"></div>
        <div class="auth-page__brand-pattern"></div>
        <div class="auth-page__brand-content">
          <h1 class="auth-page__brand-title">Quên mật khẩu?</h1>
          <p class="auth-page__brand-desc">Nhập tài khoản và email đăng ký, chúng tôi sẽ gửi hướng dẫn cấp lại mật khẩu qua email.</p>
          <ul class="auth-page__brand-features">
            <li>
              <span class="auth-page__brand-features-icon"><i class="fa fa-envelope"></i></span>
              <span><strong>Gửi qua email</strong> Link hoặc mật khẩu tạm sẽ được gửi tới địa chỉ email đã đăng ký với tài khoản.</span>
            </li>
            <li>
              <span class="auth-page__brand-features-icon"><i class="fa fa-key"></i></span>
              <span><strong>Bảo mật</strong> Chỉ khi tài khoản và email khớp với dữ liệu hệ thống thì yêu cầu mới được xử lý.</span>
            </li>
            <li>
              <span class="auth-page__brand-features-icon"><i class="fa fa-clock-o"></i></span>
              <span><strong>Xử lý nhanh</strong> Sau khi gửi thành công, vui lòng kiểm tra hộp thư (và thư mục spam) trong vài phút.</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="auth-page__form-side">
        <div class="auth-page__form-side-pattern" aria-hidden="true"></div>
        <div class="auth-page__wrap">
          <CCard no-body class="auth-page__card">
            <CCardBody class="auth-page__card-body">
              <CForm id="form-forgot" class="auth-page__form">
                <h2 class="auth-page__title form-fade-in-top">Cấp lại mật khẩu</h2>
                <p class="auth-page__subtitle">Tài khoản và email phải khớp với dữ liệu hệ thống</p>
                <div class="form-fade-in-bottom">
              <div class="mb-4">
                <BaseInput
                  :listener="userNameInput.listener"
                  :options="userNameInput.options"
                  :data="userNameInput.data"
                  class="input-wrapper"
                />
              </div>
              <div class="mb-2">
                <BaseInput
                  :listener="emailInput.listener"
                  :options="emailInput.options"
                  :data="emailInput.data"
                  class="input-wrapper"
                />
              </div>
              <div class="auth-page__btn-group auth-page__btn-group--row">
                <button type="button" class="auth-btn-secondary" @click="$router.go(-1)">
                  Hủy bỏ
                </button>
                <button type="button" class="auth-btn-primary ripple btn-primary" @click="submitForgotPass()">
                  Cấp lại mật khẩu
                  <div class="ripple-effect" hidden></div>
                </button>
              </div>
                </div>
              </CForm>
            </CCardBody>
          </CCard>
        </div>
      </div>
    </div>
    <BaseLoading :loading="loading.value"></BaseLoading>
  </div>
</template>
  <script>
  import BaseLoading from "../base/BaseFormLoading";
  import BaseInput from "../base/BaseInput";
  
  export default {
    name: "ForgotPass",
    components: { BaseInput, BaseLoading },
    notifications: {
      showSuccessMsg: {
        type: "success",
        title: "Success"
      },
      showErrorMsg: {
        type: "error",
        title: "Errors"
      },
      showWarningMsg: {
        type: "warn",
        title: "warn"
      }
    },
    mounted: function () {
    },
    created: function () {
    },
    data: function () {
      let that = this;
      return {
        loading: { value: false },
        userNameInput: {
          options: {
            placeholder: "Tài khoản",
            type: "text",
            autocomplete: "off"
          },
          data: {
            name: "username",
            model: "",
            validator: {
              isValid: true,
              errorMessage: "",
              valid: function () {
                let value = that.userNameInput.data.model;
                let username_regex = /^([a-zA-Z0-9 !%&@#$^*?_~]){6,}$/;
                if (value === "") {
                  this.isValid = false;
                  this.errorMessage = "Tên đăng nhập không được để trống";
                } else if (username_regex.test(value) == false) {
                  this.isValid = false;
                  this.errorMessage =
                    "Tên đăng nhập ít nhất 6 kí tự và là chữ thường";
                } else if (username_regex.test(value) == true) {
                  this.isValid = true;
                  this.errorMessage = "";
                }
                return this.isValid;
              }
            }
          },
          listener: {
            keyup: function (event) {
              if (event.key === "Enter") {
                that.submitForgotPass();
              }
            }
          }
        },
        emailInput: {
          options: {
            placeholder: "Email",
            type: "text",
            autocomplete: "off"
          },
          data: {
            name: "email",
            model: "",
            validator: {
              isValid: true,
              errorMessage: "",
              valid: function () {
                let value = that.emailInput.data.model;
                if (value === "") {
                  this.isValid = false;
                  this.errorMessage = "Email không được để trống";
                } else {
                  this.isValid = true;
                  this.errorMessage = "";
                }
                return this.isValid;
              }
            }
          },
          listener: {
            keyup: function (event) {
              if (event.key === "Enter") {
                that.submitForgotPass();
              }
            }
          }
        },
      };
    },
    computed: {},
    watch: {},
    methods: {
      setUpRippleButton: function () {
        $(".ripple").on("click", function (event) {
          event.preventDefault();
          let $div = $("<div/>"),
            btnOffset = $(this).offset(),
            xPos = event.pageX - btnOffset.left,
            yPos = event.pageY - btnOffset.top;
          $div.addClass("ripple-effect");
          let $ripple = $(".ripple-effect");
          $div
            .css({
              top: yPos - $ripple.height() / 2,
              left: xPos - $ripple.width() / 2
            })
            .appendTo($(this));
          window.setTimeout(function () {
            $div.remove();
          }, 1500);
        });
      },
      submitForgotPass: function () {
        let that = this;
        let isValid = true;
        isValid &= this.userNameInput.data.validator.valid();
        isValid &= this.emailInput.data.validator.valid();
        if (!isValid) {
          return;
        }
  
        that.$helper.loadDataSource({
          loading: that.loading,
          url: "/users/forgot-password",
          isJsonContentType: false,
          dataSubmit: function () {
            return {
              username: btoa(that.userNameInput.data.model),
              email: btoa(that.emailInput.data.model),
            };
          },
          successCallback: function (response) {
            let { data } = response.data;
            if (!that.$helper.validResponse(that.$router, response.data)) {
              that.showErrorMsg({ message: that.$helper.getStringError(data) });
            } else {
               that.showSuccessMsg({ message: "Mật khẩu của bạn đã được cấp lại qua email. Vui lòng kiểm tra email. Xin cảm ơn." });
               that.$router.go(-1);
            }
          },
          errorCallback: function (error) {
            that.$helper.handleError(that.$router, error);
          }
        });
      },
    }
  };
  </script>
  
  